import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { PlusDto } from "@/core/features/pluses/plus.dto";
import { CreatePlusDto } from "@/core/features/pluses/create-plus.dto";
import { UpdatePlusDto } from "@/core/features/pluses/update-plus.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { merge } from "lodash";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class PlusesResource extends ResourceBaseService<PlusDto, CreatePlusDto, UpdatePlusDto> {
  protected EntityDto = PlusDto;
  protected CreateEntityDto = CreatePlusDto;
  protected UpdateEntityDto = UpdatePlusDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/pluses");
  }

  async optionLoader(inputValue: string, customRequest?: IRequest): Promise<OptionType[]> {
    const request: IRequest = { sortBy: "name" };
    if (inputValue) {
      request.search = inputValue;
      request.searchBy = ["id", "name"];
    }
    if (customRequest) merge(request, customRequest);

    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
